import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment.prod';
import PolicyReport from '../interfaces/policy_report';
import { PolicyType } from '../enums/policy_type';

@Injectable({
    providedIn: 'root',
})
export class ReportsService {
    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) {}

    getPolicies(body: PolicyReport, policyType: PolicyType): Observable<any> {
        if (policyType === PolicyType.MOTOR) {
            return this.fetchMotorPolicies(body);
        } else {
            return this.fetchNonMotorPolicies(body);
        }
    }

    fetchMotorPolicies(body: PolicyReport): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/motor-policy-report`, body);
    }

    fetchNonMotorPolicies(body: PolicyReport): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/sme/report`, body);
    }

    fetchUsersReports(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/user/report`, body);
    }

    fetchMotorPlanReports(body: any): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/api/report/vehicle-breakdown`,
            body
        );
    }

    fetchSMEReports(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/report/sme-coupon`, body);
    }

    fetchHospitalCashbackReports(body: any): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/api/report/hospital-cashback`,
            body
        );
    }

    fetchLegalAidReports(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/report/legal-aid`, body);
    }

    fetchHomeInsuranceReports(body: any): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/api/report/home-insurance`,
            body
        );
    }

    fetchBurialAssistanceReports(body: any): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/api/report/burial-assistance`,
            body
        );
    }

    fetchCustomersReports(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/customer/report`, body);
    }
}
